import React from 'react';
import TestInterface from '../logical/TestInterface';

/**
 * Layout wrapper for the Testclient page.
 * Passes the selected execution mode down to the test interface logic.
 */
const TestclientLayout = ({ mode }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: '100%' }}>
      <main className="ids-p-6" style={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column' }}>
        <TestInterface mode={mode} />
      </main>
    </div>
  );
};

export default TestclientLayout;
